import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { buildAvatar } from '../../helpers';

/**
 * @class PlayerAvatar
 *
 * @description
 * Class for building the player avatar.
 *
 * @example
 * <PlayerAvatar />
 */
@connect(
	state => {
		const avatar = state.results.saveState ? state.results.saveState.avatar : {options: []};
		return {
			avatarOptions: avatar && avatar.options ? avatar.options : null
		}
	}
)
export default class PlayerAvatar extends Component {

	static propTypes = {
		avatarOptions: PropTypes.array,
		avatarGender: PropTypes.string
	};

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		return buildAvatar(this.props);
	}
}
